import { all } from "redux-saga/effects";
import { WatcherEcommerceApp } from '../redux/ecommerce'
import { WatcherChatApp } from '../redux/chap-app'
import { WatcherEmailApp } from '../redux/email'
import { watchTodoList } from '../redux/todo';
import { watchBookmarkList } from "../redux/bookmark";
import { watcherTaskApp } from "../redux/task-app";
import { watchLoginData } from "../redux/login";
import { watchUsersData } from "../redux/users";
import { watchSalesData } from "../redux/sales";
import { watchAffiliationsData } from "../redux/affiliations";
import { watchNavisionData } from "../redux/navision";
import { watchPolicyData } from "../redux/policy";
import { watchWalletData } from "../redux/wallet";

export default function* rootSagas() {
    yield all([
        WatcherEcommerceApp(),
        WatcherChatApp(),
        WatcherEmailApp(),
        watchTodoList(),
        watchBookmarkList(),
        watcherTaskApp(),
        watchLoginData(),
        watchUsersData(),
        watchSalesData(),
        watchAffiliationsData(),
        watchNavisionData(),
        watchPolicyData(),
        watchWalletData(),
    ])
}